export default __webpack_public_path__ + "static/media/Group 6508@3x.157a319b.png";